import $ from 'jquery';
import 'slick-carousel';

const Slider = {
    init() {
        if ($('.js-slider').length) this.initSlider();
    },

    initSlider() {
        $('.js-slider').slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: true,
            fade: true,
            infinite: true,
            lazyLoad: 'anticipated',
            mobileFirst: true,
            slidesToShow: 1,
            touchThreshold: 30,
        });
    },
};

export default Slider;
